import { useParams } from 'react-router-dom';

import Permissions from '@/common/permissions';
import useHasAccess from '@/modules/core/hooks/useHasAccess';
import { useGeneralInfoStore } from '@/modules/employee/Employee/PersonalInformation/GeneralInfo/stores';

import { useGetLettersOfMedicalNecessityQuery } from '../queries';

import useGetFileUrl from './useGetFileUrl';
import useGetPreviewForLMNs from './useGetPreviewForLMNs';

interface Params {
  page: number;
  perPage: number;
  searchString: string;
}
const useLMNList = ({ page, perPage, searchString }: Params) => {
  const { employeeId: employeeIdFromParams } = useParams<{ employeeId: string }>();
  const { employeeId: employeeIdFromStore } = useGeneralInfoStore((state) => state.state);
  const employeeId = employeeIdFromParams || employeeIdFromStore;
  const isManageLmnAvailable = useHasAccess([{ permission: Permissions.MANAGE_LMN }]);
  const { lettersOfMedicalNecessity, total, isLoading } = useGetLettersOfMedicalNecessityQuery({
    employeeId,
    page,
    perPage,
    searchString: searchString,
    disabled: !isManageLmnAvailable,
  });
  const { valuesMap } = useGetPreviewForLMNs(lettersOfMedicalNecessity);
  const { getFileUrl } = useGetFileUrl({ valuesMap });

  return {
    isLoading,
    lettersOfMedicalNecessity,
    getFileUrl,
    total,
    valuesMap,
  };
};
export default useLMNList;
